export default __webpack_public_path__ + "static/media/connected.e908d655.jpg";